import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const uploadFileCardTemplate = htmlE`
  <div class="upload-file-card is-flex is-align-items-center" data-file-id="${({
    id,
  }) =>
    utils.textEncode(id || "")}" title="Alt+Click to copy debug information">
  ${({ checked, hideCheckbox }) => {
    if (!hideCheckbox) {
      return `<label class="is-cursor-pointer">
          <input${checked ? ` checked` : ""} class="checkbox" type="checkbox" />
        </label>`;
    }
  }}
    <div class="is-relative">
      <div class="upload-file-card-icon-wrapper is-align-items-center is-justify-content-center is-flex">
        ${({ image }) => image || ""}
      </div>

      ${({ uploadType }) => {
        if (uploadType === "WS") {
          return `<i class="upload-type-badge text-accentMain icon-bolt"></i>`;
        }
      }}
    </div>
    <div class="upload-file-card-details-container is-flex is-flex-direction-column is-justify-content-space-between">
      <div class="file-details-left-section is-flex is-flex-direction-column">
        <div class="is-flex is-align-items-center is-justify-content-space-between">
          ${({ name }) =>
            `
          <p title="${utils.escapeHtmlAttr(
            name || ""
          )}" class="text-sm whitespace-nowrap is-clipped is-ellipsis is-user-select-all mr-5">
            ${utils.textEncode(name)}
          </p>
          `}
          <span class="chunk-preparation-stalled text-xs text-error is-hidden">
            <i class="icon-warning-sign"></i>
            <span>Chunk preparation is stalled...</span>
          </span>
          ${({ size, lastModifiedF }) =>
            `
          <p class="text-xs whitespace-nowrap ml-5"><span>${size}</span>, <span>${lastModifiedF}</span></p>
          `}
        </div>

        <div class="is-flex is-align-items-center is-justify-content-space-between gap-3">
          <div class="is-flex is-align-items-center gap-3">
          ${({
            completedPercentage,
            uploadedBytes,
            sizeInBytes,
            showProgressBar,
          }) => {
            return `<div class="progress-bar-container progress-bar${
              !showProgressBar ? ` is-hidden` : ``
            }">
              <progress class="progress success-progress" value="${uploadedBytes}" max="${sizeInBytes}"></progress>
          </div>
          <span id="completed-percentage" class="text-xs${
            !showProgressBar ? ` is-hidden` : ``
          }">${completedPercentage}</span>
          </div>`;
          }}
          <div class="action-button-wrapper is-flex is-align-items-center">

      ${({ customFormData, detailsTet }) => {
        if (customFormData) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="detail-button">
            <i class="icon-edit mr-2"></i>
            <span data-i18n-key="details">${detailsTet}</span>
          </button>`;
        }
      }}

      ${({ overWriteButton, overwriteText }) => {
        if (overWriteButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="overwrite-button">
            <i class="icon-copy mr-2"></i>
            <span data-i18n-key="overwrite">${overwriteText}</span>
          </button>`;
        }
      }}

      ${({ resumeButton, resumeText }) => {
        if (resumeButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="resume-button">
            <i class="icon-paste mr-2"></i>
            <span data-i18n-key="resume">${resumeText}</span>
          </button>
          `;
        }
      }}

      ${({ uploadButton, uploadText }) => {
        if (uploadButton) {
          return `<button class="primary-button is-bg-none p-1 text-xs" id="upload-button">
            <i class="icon-upload-alt mr-2"></i>
            <span data-i18n-key="Upload">${uploadText}</span>
          </button>`;
        }
      }}

      ${({ pauseButton, pauseText }) => {
        if (pauseButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="pause-button">
            <i class="icon-pause mr-2"></i>
            <span data-i18n-key="pause">${pauseText}</span>
          </button>`;
        }
      }}

      ${({ waitingButton, waitingText }) => {
        if (waitingButton) {
          return `<span class="text-primaryMain text-sm"><span data-i18n-key="waiting">${waitingText}</span><span>...</span></span>`;
        }
      }}

      ${({ pausingButton, pausingText }) => {
        if (pausingButton) {
          return `<span class="text-primaryMain text-sm"><span data-i18n-key="pausing">${pausingText}</span><span>...</span></span>`;
        }
      }}

      ${({ cancelingButton, cancelingText }) => {
        if (cancelingButton) {
          return `<span class="text-primaryMain text-sm"><span data-i18n-key="canceling">${cancelingText}</span><span>...</span></span>`;
        }
      }}

      ${({ finalizingButton, finalizingText, finalizingMsg }) => {
        if (finalizingButton) {
          return `
          <div class="upload-finalizing-box is-absolute is-flex is-align-items-center is-justify-content-center text-primaryMain h-full w-full">
            <i class="icon-folder-open text-accentMain mr-2"></i>
            <span class="text-sm" data-i18n-key="finalizing">${
              finalizingMsg || finalizingText
            }</span><span>...</span>
          </div>`;
        }
      }}

      ${({ reUploadButton, reuploadText }) => {
        if (reUploadButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="reupload-button">
            <i class="icon-refresh mr-2"></i>
            <span data-i18n-key="reupload">${reuploadText}</span>
          </button>
          `;
        }
      }}

      ${({ resumePauseButton, resumeText }) => {
        if (resumePauseButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="resume-pause-button">
            <i class="icon-play mr-2"></i>
            <span data-i18n-key="resume">${resumeText}</span>
          </button>`;
        }
      }}

      ${({ cancelButton, cancelText }) => {
        if (cancelButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="cancel-button">
            <i class="icon-remove mr-2"></i>
            <span data-i18n-key="cancel">${cancelText}</span>
          </button>`;
        }
      }}

      ${({ removeButton, removeText }) => {
        if (removeButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="remove-button">
            <i class="icon-trash mr-2 text-error"></i>
            <span data-i18n-key="remove">${removeText}</span>
          </button>`;
        }
      }}
      </div>
        </div>

        <div class="is-flex is-justify-content-space-between">
          <p class="error-message-left text-xs text-error">
            ${({ listingError }) => {
              if (listingError) {
                return `<i class="icon-warning-sign"></i>
                  <span>${utils.textEncode(listingError)}</span>`;
              }
            }}
            ${({
              showProgressBar,
              uploadedBytesFormatted,
              size,
              elapsedTime,
              timeRemaining,
              speed,
              overAllSpeed,
              averageSpeedText,
              elapsedText,
              remainingText,
              speedText,
            }) => {
              return `<span class="upload-progress-status${
                !showProgressBar ? ` is-hidden` : ``
              } text-xs">
                <span id="fileSizeUploaded">${uploadedBytesFormatted}</span> of <span id="fileSize">${size}</span> | <i class="icon-time"></i> : <b><span data-i18n-key="elapsed">${elapsedText}</span> / <span data-i18n-key="remaining">${remainingText}</span></b> :  <span id="elapsedTime">${elapsedTime}</span> / <span id="remainingTime">${timeRemaining}</span> | <b data-i18n-key="speed">${speedText}</b> :
                <span id="uploadingSpeed">${speed}</span> | <b data-i18n-key="averageSpeed">${averageSpeedText}</b> :
                <span id="uploadingAverageSpeed">${overAllSpeed}</span>
              </span>
            </p>`;
            }}

          <p class="error-message-right text-xs">
            ${({ completionMessage, timeTaken, averageUploadingSpeed }) => {
              if (completionMessage) {
                return `<span data-i18n-key="uploadedInSecAtAnAverageSpeed" data-i18n-opt='{"time": "${timeTaken}", "speed" : "${averageUploadingSpeed}"}' class="text-primaryMain">${completionMessage}</span>`;
              }
            }}
            ${({ uploadingError }) => {
              if (uploadingError) {
                return `<span class="text-error">${utils.textEncode(
                  uploadingError
                )}</span>
                  <i class="text-error icon-warning-sign"></i>`;
              }
            }}
          </p>
        </div>
      </div>

    </div>
  </div>`;

export const uploadFileButtonContainerTemplate = htmlE`
  <div
    id="uploadFileButtonContainer"
    class="drag-and-drop-upload-box p-5 is-flex is-flex-direction-column is-justify-content-center is-align-items-center gap-3"
  >
      <i class="icon-upload-alt"></i>
      <p data-i18n-key="dragAndDropFileHere" class="mt-3">
        ${"dragAndDropFileHereText"}
      </p>
      <button
        id="uploadFileButton"
        data-i18n-key="uploadFiles"
        class="primary-button"
      >
      ${"uploadFilesText"}
      </button>
    </div>
  `;

export const globalFileCardTemplate = htmlE`
  <div class="upload-file-card is-flex is-align-items-center">
    <div class="upload-file-card-details-container is-flex is-flex-direction-column is-justify-content-space-between">
      <div class="file-details-left-section is-flex is-flex-direction-column">
        <div class="is-flex is-align-items-center is-justify-content-space-between">
          ${({ name, uploadingText }) =>
            `
          <p title="${utils.escapeHtmlAttr(
            name || ""
          )}" class="text-sm whitespace-nowrap is-clipped is-ellipsis is-user-select-all mr-5">
            <b data-i18n-key="uploading">${utils.textEncode(
              uploadingText
            )}</b> : <span id="current-uploading-file-global">${utils.textEncode(
              name
            )}</span>
          </p>
          `}
          ${({ currentUploadingFileNumber, totalUploadingFiles }) =>
            `
          <p id="global-upload-file-count" class="text-xs whitespace-nowrap ml-5">${currentUploadingFileNumber} of total ${totalUploadingFiles} item(s)</p>
          `}
        </div>

        <div class="is-flex is-align-items-center is-justify-content-space-between gap-3">
          <div class="is-flex is-align-items-center gap-3">
          ${({
            completedPercentage,
            totalBytesUploaded,
            totalBytesToUpload,
            showProgressBar,
          }) => {
            return `<div class="progress-bar-container progress-bar${
              !showProgressBar ? ` is-hidden` : ``
            }">
              <progress class="progress success-progress" value="${totalBytesUploaded}" max="${totalBytesToUpload}"></progress>
          </div>
          <span id="completed-percentage" class="text-xs${
            !showProgressBar ? ` is-hidden` : ``
          }">${completedPercentage}</span>
          </div>`;
          }}

      <div class="action-button-wrapper is-flex is-align-items-center">

      ${({ skipButton, skipText }) => {
        if (skipButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="skip-button">
            <i class="icon-forward mr-2"></i>
            <span data-i18n-key="skip">${skipText}</span>
          </button>`;
        }
      }}

      ${({ pauseButton, pauseText }) => {
        if (pauseButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="pause-button">
            <i class="icon-pause mr-2"></i>
            <span data-i18n-key="pause">${pauseText}</span>
          </button>`;
        }
      }}

      ${({ pausingButton, pausingText }) => {
        if (pausingButton) {
          return `<span class="text-primaryMain text-sm"><span data-i18n-key="pausing">${pausingText}</span><span>...</span></span>`;
        }
      }}

      ${({ cancelingButton, cancelingText }) => {
        if (cancelingButton) {
          return `<span class="text-primaryMain text-sm"><span data-i18n-key="canceling">${cancelingText}</span><span>...</span></span>`;
        }
      }}

      ${({ resumePauseButton, resumeText }) => {
        if (resumePauseButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="resume-pause-button">
            <i class="icon-play mr-2"></i>
            <span data-i18n-key="resume">${resumeText}</span>
          </button>`;
        }
      }}

      ${({ cancelButton, cancelText }) => {
        if (cancelButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="cancel-button">
            <i class="icon-remove mr-2"></i>
            <span data-i18n-key="cancel">${cancelText}</span>
          </button>`;
        }
      }}

      </div>
        </div>

        <div class="is-flex is-justify-content-space-between">
          <p class="error-message-left text-xs text-error">
            ${({
              showProgressBar,
              uploadedBytesFormatted,
              size,
              elapsedTime,
              timeRemaining,
              overAllSpeed,
              averageSpeedText,
              elapsedText,
              remainingText,
            }) => {
              return `<span class="upload-progress-status${
                !showProgressBar ? ` is-hidden` : ``
              } text-xs">
                <span id="fileSizeUploaded">${uploadedBytesFormatted}</span> of <span id="fileSize">${size}</span> | <i class="icon-time"></i> : <b><span data-i18n-key="elapsed">${elapsedText}</span> / <span data-i18n-key="remaining">${remainingText}</span></b> :  <span id="elapsedTime">${elapsedTime}</span> / <span id="remainingTime">${timeRemaining}</span> | <b data-i18n-key="averageSpeed">${averageSpeedText}</b> :
                <span id="uploadingAverageSpeed">${overAllSpeed}</span>
              </span>
            </p>`;
            }}
        </div>
      </div>

    </div>
  </div>`;
